export default __webpack_public_path__ + "static/media/wsc.389cf88c.svg";